import { setSortingPreferences } from './setSortingPreferences';
import { startSearch } from './startSearch';

import type { Store } from '../../../store/list/types';

export const onSortingChange = (store: Store, by: string, reverse: boolean): void => {
  const { setSortBy } = store.getState();
  const columnToApiNames: Record<string, string> = {
    start_path: 'first_page_path.raw',
    created_epoch_time: 'created',
  };
  const newSortBy = (reverse ? '-' : '') + (columnToApiNames[by] || by);

  setSortBy(newSortBy);
  setSortingPreferences(newSortBy);
  startSearch(store);
};
